import arrowDown from './assets/arrow-down-red.svg'

const SelectArrow = () => {
    return (
        <img className="select-arrow" src={arrowDown} alt="arrow-down" />
    )
}

export default SelectArrow;